import React, { useState, useEffect, useContext } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { AuthContext } from './AuthContext';

export default function HistoryPanel() {
  const { user } = useContext(AuthContext);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    async function fetchHistory() {
      const q = query(collection(db, 'chats'), where('uid', '==', user.uid));
      const snap = await getDocs(q);
      setHistory(snap.docs.map(d => d.data()));
    }
    fetchHistory();
  }, [user]);

  return (
    <div>
      <h2>Chat History</h2>
      <ul>
        {history.map((h, i) => (
          <li key={i}>{h.prompt} – {h.createdAt?.toDate().toLocaleString()}</li>
        ))}
      </ul>
    </div>
  );
}
